import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import PageWithHeader from './components/PageWithHeader';
import Fun from './pages/Fun';
import Projects from './pages/Projects';
import About from './pages/About';
import Tags from './pages/Tags';
import Archive from './pages/Archive';
import Notes from './pages/Notes';
import BuildingPersonalWebsite from './pages/notes/BuildingPersonalWebsite';

function App() {
  return (
    <div className="font-playpen">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route element={<PageWithHeader />}>
            <Route path="/fun" element={<Fun />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/about" element={<About />} />
            <Route path="/notes" element={<Notes />} />
            <Route path="/notes/building-personal-website" element={<BuildingPersonalWebsite />} />
            <Route path="/tags" element={<Tags />} />
            <Route path="/archive" element={<Archive />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;